export var ECTABlockButtonSizes = /* @__PURE__ */ ((ECTABlockButtonSizes2) => {
  ECTABlockButtonSizes2["SMALL"] = "SMALL";
  ECTABlockButtonSizes2["MEDIUM"] = "MEDIUM";
  ECTABlockButtonSizes2["LARGE"] = "LARGE";
  return ECTABlockButtonSizes2;
})(ECTABlockButtonSizes || {});
export var ECTABlockButtonAlignment = /* @__PURE__ */ ((ECTABlockButtonAlignment2) => {
  ECTABlockButtonAlignment2["LEFT"] = "LEFT";
  ECTABlockButtonAlignment2["CENTER"] = "CENTER";
  ECTABlockButtonAlignment2["RIGHT"] = "RIGHT";
  return ECTABlockButtonAlignment2;
})(ECTABlockButtonAlignment || {});
export var ECTABlockLinkSizes = /* @__PURE__ */ ((ECTABlockLinkSizes2) => {
  ECTABlockLinkSizes2["XSMALL"] = "XSMALL";
  return ECTABlockLinkSizes2;
})(ECTABlockLinkSizes || {});
export var ECTABlockButtonVariants = /* @__PURE__ */ ((ECTABlockButtonVariants2) => {
  ECTABlockButtonVariants2["PRIMARY"] = "primary";
  ECTABlockButtonVariants2["SECONDARY"] = "secondary";
  ECTABlockButtonVariants2["PLAIN"] = "plain";
  ECTABlockButtonVariants2["ACCENT"] = "accent";
  return ECTABlockButtonVariants2;
})(ECTABlockButtonVariants || {});
export var ECTABlockLinkVariant = /* @__PURE__ */ ((ECTABlockLinkVariant2) => {
  ECTABlockLinkVariant2["STANDARD"] = "standard";
  ECTABlockLinkVariant2["CHEVRON"] = "chevron";
  ECTABlockLinkVariant2["ANCHOR"] = "anchor";
  return ECTABlockLinkVariant2;
})(ECTABlockLinkVariant || {});
export var ECTActionOption = /* @__PURE__ */ ((ECTActionOption2) => {
  ECTActionOption2["URL"] = "url";
  ECTActionOption2["MODAL"] = "modal";
  ECTActionOption2["ANCHOR"] = "anchor";
  return ECTActionOption2;
})(ECTActionOption || {});
